'use client';

import { css } from '@emotion/react';

import themeStyles, { campaignManagerTheme } from './lib/theme';

export default css`
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-play-state: paused !important;
      transition: none !important;
      scroll-behavior: auto !important;
    }
  }
  :root {
    ${themeToVariables(themeStyles)}
  }
  * {
    box-sizing: border-box;
  }
  .invisible {
    visibility: hidden;
  }
  .hideOnDesktop {
    display: none;
  }
  a,
  button {
    cursor: pointer;
  }
  a {
    text-decoration: unset;
  }
  h1,
  h2,
  h3,
  h4 {
    padding: 0;
    margin: 0;
    font-weight: 400;
  }
  p {
    margin: 0;
  }
  html,
  body {
    height: 100vh;
    min-height: 100vh;
    max-width: 100%;
    padding: 0;
    margin: 0;
    color: ${campaignManagerTheme.color.black};
    font-family: ${campaignManagerTheme.fontFamily.default};
    font-kerning: auto;
    font-smooth: auto;
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
  @media screen and (max-width: 768px) {
    .hideOnMobile {
      display: none;
    }
    .hideOnDesktop {
      display: unset;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  /* Animation */

  :root {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1;
  }

  @keyframes headShake {
    0% {
      transform: translateX(0);
    }

    6.5% {
      transform: translateX(-6px) rotateY(-9deg);
    }

    18.5% {
      transform: translateX(5px) rotateY(7deg);
    }

    31.5% {
      transform: translateX(-3px) rotateY(-5deg);
    }

    43.5% {
      transform: translateX(2px) rotateY(3deg);
    }

    50% {
      transform: translateX(0);
    }
  }

  .animated {
    animation-duration: var(--animate-duration);
    animation-fill-mode: both;
  }

  .animated.infinite {
    animation-iteration-count: infinite;
  }

  .animated.repeat-1 {
    animation-iteration-count: var(--animate-repeat);
  }

  .headShake {
    animation-timing-function: ease-in-out;
    animation-name: headShake;
  }
`;

function themeToVariables(theme: any) {
  return Object.entries(theme)
    .flatMap(([styleKey, styleValues]) =>
      Object.entries(styleValues as object).map(
        ([key, value]) => `--${styleKey}-${key}: ${value};`,
      ),
    )
    .join('\n');
}
